export default "__VITE_ASSET__21148249__"